module.exports = __webpack_public_path__ + "img/default_page.fda697cd.png";